import { NgModule } from '@angular/core';
import { NgLetDirective } from './ng-let.directive';

@NgModule({
  declarations: [NgLetDirective],
  imports: [],
  exports: [NgLetDirective],
  providers: []
})
export class NgLetModule { }
